"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionAttachments = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const compliance_pool_types_1 = require("../compliance-pool-types");
const TransactionAttachmentTable_1 = require("../common/tables/TransactionAttachmentTable");
const common_styled_components_1 = require("../../common-styled-components");
const transactionAttachmentUtil_1 = require("./util/transactionAttachmentUtil");
const TransactionAttachments = ({ transactionAttachments, selectedYear, shipId, isInAdminTools, refresh, }) => {
    const groupedAttachments = (0, react_1.useMemo)(() => {
        return {
            1: transactionAttachments.filter(compliance_pool_types_1.isPeriodicalStatement),
            2: transactionAttachments.filter(compliance_pool_types_1.isBunkerDeliveryNote),
        };
    }, [transactionAttachments]);
    return ((0, jsx_runtime_1.jsx)("div", { children: Object.keys(groupedAttachments).map((attachmentType) => {
            const attachmentTypeKey = Number(attachmentType);
            const attachments = groupedAttachments[attachmentTypeKey];
            if (attachments.length === 0 && !isInAdminTools) {
                return null;
            }
            return ((0, jsx_runtime_1.jsxs)("div", { style: { marginBottom: "2rem" }, children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallSubtitle, { children: transactionAttachmentUtil_1.ATTACHMENT_TYPE_LABELS[attachmentTypeKey].plural }), (0, jsx_runtime_1.jsx)(TransactionAttachmentTable_1.TransactionAttachmentTable, { transactionAttachments: attachments, attachmentType: attachmentTypeKey, selectedYear: selectedYear, shipId: shipId, isInAdminTools: isInAdminTools, refresh: refresh, periodicalStatementOptions: groupedAttachments[1]?.map((file) => ({
                            value: file.id,
                            label: file.name,
                        })) })] }, attachmentType));
        }) }));
};
exports.TransactionAttachments = TransactionAttachments;
